import { render } from "./PropertiesImportView.vue?vue&type=template&id=bc7b05c0&scoped=true"
import script from "./PropertiesImportView.vue?vue&type=script&lang=js"
export * from "./PropertiesImportView.vue?vue&type=script&lang=js"

import "./PropertiesImportView.vue?vue&type=style&index=0&id=bc7b05c0&scoped=true&lang=css"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc7b05c0"]])

export default __exports__